import { useSelector } from 'react-redux'

import { isEngageDAProvider } from '../common/utils/utils'
import { getAuthRoles } from '../data/auth/authSelectors'

export const useIsEngageDAProvider = () => {
  const roles = useSelector(getAuthRoles)
  return isEngageDAProvider(roles)
}
